// src/components/Footer.js
import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="app-footer">
      <p>
        Built by a creator, for creators © {new Date().getFullYear()} ProdPilot App {' '}
        <a
          href="https://buymeacoffee.com/prodpilot"
          target="_blank"
          rel="noopener noreferrer"
          className="coffee-link"
        >
          ☕ Help me build
        </a>
      </p>
    </footer>
  );
}

